<template>
  <section id="partner" class="partner">
    <div class="section-caption">{{ $t("partner_headline") }}</div>
    <p class="caption-partner">
      {{ $t("partner_tagline") }}
    </p>
    <div class="container">
    <vueper-slides
      class="no-shadow"
      :visible-slides="6"
      slide-multiple
      :gap="6"
      :slide-ratio="1 / 4"
      :autoplay=true
      :arrows=false
      :dragging-distance="100"
      :breakpoints="{ 150: { visibleSlides: 2, slideMultiple: 2 } }">
      <vueper-slide
      v-for="(partner, index) in partners" :key="index"
      :image="partner.image_jpg"
      class="feature-img center" />
    </vueper-slides>
    </div>
    <div class="container"
      style="margin: auto; width: 50%; padding-top: 100px; padding-bottom: 0px;">
      <div class="getintouch">
        <div class="getintouch-caption">
          {{ $t("getintouch") }}
        </div>
      <br />
      <div class="getintouch-content">
      <p style="align: center;">
        {{ $t("getintouch_tagline") }}
      </p>
      </div>
      <b-button
        href="mailto:salescorp@paxel.co"
        style="background-color: #5e51a1"
        class="getintouch-button"
      >
        <img src="@/assets/images/ic-email.svg" alt="" />
        salescorp@paxel.co
      </b-button>
      </div>
    </div>
  </section>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';

export default {
  name: 'Partner',
  components: {
    VueperSlides,
    VueperSlide,
  },
  data() {
    return {
      visible: false,
      partners: [],
      morePartner: [],
      loadingBanner: true,
      rowSize: 6,
      slides: [
        {
          title: 'Slide #1',
          content: 'Slide content.',
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch('fetchPartnerpage', {
      language: this.$store.getters.getLanguage,
      limit: 100,
      search_param: '',
      page: 1,
    });
  },
  created() {
    this.$store.watch(
      (state) => state.homepagePartner,
      (newValue) => {
        this.loadingBanner = true;
        this.partners = newValue;
        this.loadingBanner = false;
      },
    );
    this.$store.watch(
      (state) => state.language,
      (newValue) => {
        this.$store.dispatch('fetchPartnerpage', {
          language: newValue,
          limit: 100,
          search_param: '',
          page: 1,
        });
      },
    );
  },
  computed: {
    makeRows() {
      const row = [];
      let i = this.rowSize;
      let l = this.rowSize;
      const chunkSize = this.rowSize;

      for (i = 6, l = this.partners.length; i < l; i += chunkSize) {
        row.push(this.partners.slice(i, i + chunkSize));
      }
      return row;
    },
  },
};
</script>
<style scoped>
.desktop-home .partner {
  /* border-bottom: 1px dashed #000000; */
  margin-bottom: 100px;
  padding: 0px;
  text-align: center;
}
.desktop-home .getintouch-content {
  font-family: "GothamBook";
  font-size: 16px;
  /* font-weight: bold; */
  font-stretch: normal;
  font-style: normal;
  line-height: 27px;
  letter-spacing: 0.36px;
  margin-bottom: 20px;
}
.desktop-home .getintouch-caption {
  font-family: "GothamMedium";
  font-size: 24px;
  /* font-weight: bold; */
  font-stretch: normal;
  font-style: normal;
  line-height: 27px;
  letter-spacing: 0.36px;
  margin-bottom: 20px;
}
.desktop-home .getintouch-button {
  font-family: "GothamMedium";
  font-size: 14px;
  /* font-weight: bold; */
  font-stretch: normal;
  font-style: normal;
  line-height: 27px;
  letter-spacing: 0.36px;
  margin-bottom: 20px;
}
.desktop-home .section-caption {
  text-align: left;
  margin-left: 100px !important;
  height: 30px;
}
.desktop-home .caption-partner {
  font-family: "GothamBook";
  font-size: 16px;
  text-align: left;
  margin-left: 100px !important;
}
.desktop-home .section-caption {
  margin-left: 0px;
}
.desktop-home .feature-img {
  width: 150px;
  height: 70px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top:100px;
  background-color:#fafbfc;
  box-shadow: 1px 1px 1px 1px #fafbfc;
;
}
.feature-headline {
  text-align: center;
}
</style>
